import { fetch as apiFetch } from '../fetchWrapper/fetch';
import { API_URL as publishApiUrl } from '../constants';

export const cancelScheduledPublish = async (menuId: string): Promise<Response> => {
  try {
    const response = await apiFetch(`${publishApiUrl}/publish/${menuId}/cancel`, { method: 'POST' });
    if (!response.ok) throw new Error(response.statusText);
    return response;
  } catch (error) {
    throw new Error('Could not cancel scheduled publish', { cause: error });
  }
};
